<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <!-- <div class="container-fluid"> -->
        <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed" aria-controls="navbarNav"
            aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div [ngbCollapse]="isCollapsed" class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav mr-auto">

                <!-- Settings Dropdown -->
                <li class="nav-item btnAppList" ngbDropdown *ngFor="let nav of navItems">
                    <ng-container *ngIf="nav.menu; else singleLink">
                        <button mat-button [matMenuTriggerFor]="menu">
                            {{ nav.label }}
                        </button>
                        <mat-menu #menu="matMenu" class="app-dropdown" xPosition="before">
                            <div class="noti-list">
                                <ul class="menu"
                                    style="display: flex; flex-wrap: wrap; padding: 0; margin: 0; list-style: none;">
                                    <li *ngFor="let row of nav.menu"
                                        style="margin: 10px; width: 100px; text-align: center;">
                                        <a [routerLink]="row.routerLink" class="app-icons" (click)="isCollapsed = true"
                                            style="text-decoration: none;">
                                            <i [class]="row.icon"></i>
                                            <p class="tx-12 mb-0">{{ row.label }}</p>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </mat-menu>
                    </ng-container>
                    <ng-template #singleLink>
                        <a mat-button [routerLink]="nav.routerLink" class="app-icons">
                            <i *ngIf="nav.icon" [class]="nav.icon"></i>
                            <span>{{ nav.label }}</span>
                        </a>
                    </ng-template>
                </li>


            </ul>
            <ul class="navbar-nav ml-auto d-flex align-items-center" style="margin-left:auto;">
                <!-- Notifications -->
                <li>
                    <button mat-button [matMenuTriggerFor]="notificationMenu">
                        <app-feather-icons [icon]="'bell'" [class]="'header-icon'"></app-feather-icons>
                    </button>
                    <mat-menu #notificationMenu="matMenu" class="nfc-menu" xPosition="before">
                        <!-- ... notification content ... -->
                    </mat-menu>
                </li>
                <!-- Profile/User menu -->
                <li class="nav-item user_profile">
                    <button mat-button [matMenuTriggerFor]="profilemenu">
                        <div class="chip dropdown-toggle" ngbDropdownToggle>
                            <span>{{ userData.user.name }}</span>
                        </div>
                    </button>
                    <mat-menu #profilemenu="matMenu" class="profile-menu">
                        <button mat-menu-item>
                            <app-feather-icons [icon]="'user'" [class]="'user-menu-icons'">
                            </app-feather-icons>Account
                        </button>
                        <button mat-menu-item (click)="logout()">
                            <app-feather-icons [icon]="'log-out'" [class]="'user-menu-icons'">
                            </app-feather-icons>Logout
                        </button>
                    </mat-menu>
                </li>
            </ul>
        </div>
    <!-- </div> -->
</nav>